const _ = importLib('lodash');
const M = importLib('moment');
// const Vuex = importLib('Vuex');
const getHelpers = importLib('getHelpers');

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');

_.mixin({
    imgPath: getImagePath,
    filePath: getAssetPath,
    str: formatString,
});

export default {
    computed: {
        _() {
            return _;
        },

        api() {
            return api;
        },
    },

    methods: {
        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },

        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },
    }
}
